export const supportedLocales = {
  en: 'Angol',
  hu: 'Magyar',
};

export const fallBackLocale = 'hu';
